import { Avatar } from "@cynthai/ui";
import type { ComponentProps } from "react";

import { getFileUrl } from "@/core/lib/api";
import type { UserReadSimple } from "@/openapi";

export type AvatarUser = Pick<UserReadSimple, "full_name" | "image_url">;

export function UserAvatar({
  user,
  size = "2xs",
  className,
}: Readonly<{
  user: AvatarUser;
  size?: Exclude<ComponentProps<typeof Avatar>["size"], undefined>;
  className?: string;
}>) {
  return (
    <Avatar
      size={size}
      circle
      src={user.image_url ? getFileUrl({ src: user.image_url }) : null}
      alt={user.full_name}
      name={user.full_name}
      className={className}
    />
  );
}
